export default __webpack_public_path__ + "static/media/calendar.6cb6a393.svg";